import { sample } from 'effector';
import {getUnviewedPopupsFx, LoginEvent} from '../../entities/popup';

sample({
    clock: LoginEvent,
    fn: () => undefined,
    target: getUnviewedPopupsFx,
});